module.exports = __webpack_public_path__ + "static/media/EDIT2-EI_Caratula3.d70e5274.png";